module.exports = __webpack_public_path__ + "static/macarons_gifts_02-2b5bb900237c160901b7c1b387c39312.jpg";